module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point03/th_03-7e7a492b99ed7dca845bc056a4b3b09a.jpg";